const Options = [
    'Indian - English',
    'Indian - Hindi',
    'Non - Indian'
]
export default Options;